<thred-dashboard-shell>
  <div toolbar-left style="display: flex">
    <img
      [ngClass]="homePath ? 'home' : ''"
      [src]="logoPath"
      style="height: 40px"
      (click)="goToHome()"
    />
  </div>
  <div toolbar-center></div>
  <div toolbar-right>
    <button mat-button (click)="logout()">Logout</button>
  </div>
  <div left>
    <thred-side-menu></thred-side-menu>
  </div>
  <ng-container main>
    <router-outlet></router-outlet>
  </ng-container>
</thred-dashboard-shell>
